import React from 'react'

import { NavLink as RouterNavLink, NavLinkProps, useParams } from 'react-router-dom'

import { DamagedDetailTable } from 'src/components/Table/detail/Damaged'

import { skuit } from 'src/services/skuit'
import { useQuery } from 'react-query'

import { DetailPage } from 'src/components/Pages/DetailPage'

const NavLink = React.forwardRef((props: NavLinkProps, ref: React.Ref<HTMLAnchorElement>) => (
  <RouterNavLink innerRef={ref} {...props} />
))
NavLink.displayName = 'NavLink'

interface PathProps {
  guid: string
}

export const DamagedPage = () => {
  const { guid } = useParams<PathProps>()

  const damaged = useQuery(['damaged-details', guid], () => skuit.client.damaged.retrieve(guid))

  const refresh = () => {
    damaged.refetch()
  }

  return (
    <>
      <DetailPage
        obj={damaged}
        title="Damaged"
        refresh={refresh}
        breadcrumbs={[
          { title: 'Dashboard', url: '/' },
          { title: 'Damages', url: '/inventory/damages' },
        ]}
        detailComponent={
          <DamagedDetailTable
            obj={damaged}
            fields={[
              'guid',
              'facility',
              'asn',
              'product',
              'sku',
              'damage',
              'damagedBy',
              'notes',
              'damagedOn',
            ]}
            refresh={refresh}
          />
        }
      />
    </>
  )
}
